/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

/**
 * The resulting parse tree nodes of the parse tree.
 */
function ParseNode(type, value, mode) {
    this.type = type;
    this.value = value;
    this.mode = mode;
}

module.exports = {
    ParseNode: ParseNode,
};





/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/katex/src/parseData.js
 ** module id = 626
 ** module chunks = 0
 **/